<template>
  <div class="fixed-top">
    <Header />

    <div class="Home-BackCh">
      <div class="container">
        <div class="row"></div>
      </div>
    </div>
  </div>

  <slot />

  <Footer />
</template>

<script>
import Header from './header.vue';
import Footer from './footer.vue';

export default {
  components: {
    Header,
    Footer,
  },
  data: () => ({
    error: null,
    isQuote: false,
    isinfo: false,
    ispayment: false,
    showheadDiv: false,
    iswelcome: false,
    QuoteTotal: 0,
  }),
  mounted() {
    var currentUrl = window.location.pathname;
    if (currentUrl == '/') {
      this.showheadDiv = false;
    }
    if (currentUrl == '/quote') {
      this.showheadDiv = true;
      this.isinfo = false;
      this.ispayment = false;
      this.isQuote = true;
    }

    if (currentUrl == '/info') {
      this.showheadDiv = true;
      this.isQuote = false;
      this.ispayment = false;
      this.isinfo = true;
    }
    if (currentUrl == '/payment') {
      this.showheadDiv = true;
      this.isQuote = false;
      this.isinfo = false;
      this.ispayment = true;
    }
    if (currentUrl == '/welcome') {
      this.showheadDiv = true;
      this.isQuote = false;
      this.isinfo = false;
      this.ispayment = false;
      this.iswelcome = true;
    }
  },
  methods: {},
};
</script>
